import Markdown from 'react-markdown';

const ALIGN_CLASSES = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right'
};

const GlossaryTable = ({ caption, headers = [], rows = [] }) => {
  if (!rows.length) return null;

  return (
    <figure className="my-7">
      {caption && <figcaption className="text-grey-600 mb-3 text-sm">{caption}</figcaption>}
      <div className="-mx-[5vw] overflow-x-auto px-[5vw] sm:mx-0 sm:px-0">
        <table className="text-grey-800 w-full border-collapse text-sm sm:text-[15px]">
          {headers.length > 0 && (
            <thead>
              <tr>
                {headers.map((header) => (
                  <th
                    key={header.id}
                    className={`bg-grey-50 text-grey-500 border-grey-200 border-b px-3 py-2.5 text-[11px] font-semibold tracking-[0.04em] whitespace-nowrap uppercase sm:px-4 sm:py-3 sm:text-[13px] ${ALIGN_CLASSES[header.align] || ALIGN_CLASSES.left}`}
                  >
                    {header.label}
                  </th>
                ))}
              </tr>
            </thead>
          )}
          <tbody className="[&_tr:last-child>td]:border-b-0">
            {rows.map((row) => (
              <tr key={row.id} className="hover:bg-grey-50 transition-colors">
                {row.cells?.map((cell) => (
                  <td
                    key={cell.id}
                    className={`border-grey-200 border-b px-3 py-3 align-top sm:px-4 sm:py-3.5 ${
                      cell.highlight
                        ? 'text-brand-500 text-[22px] leading-none font-light sm:text-[28px]'
                        : 'text-grey-800'
                    }`}
                    style={cell.highlight ? { fontFamily: 'var(--font-poly)' } : undefined}
                  >
                    <div className="inline [&_a]:underline [&_p]:m-0 [&_p]:inline">
                      <Markdown
                        components={{
                          a: ({ href, children }) => {
                            const isExternal = href && !href.startsWith('/') && !href.startsWith('#');
                            return (
                              <a href={href} {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
                                {children}
                              </a>
                            );
                          }
                        }}
                      >
                        {cell.content || ''}
                      </Markdown>
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </figure>
  );
};

export default GlossaryTable;
